import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { IProductPageResponse } from '@ncg/data';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ProductPageService } from '../../../page/product-page/product-page.service';

@Component({
    selector: 'ncg-test-drive-button',
    standalone: true,
    template: `
        <button *ngIf="show" type="button" [ngClass]="buttonClass" (click)="productPageService.openTestDrive(productPageData?.useSeezTestDrive)">
            {{ productPageData?.testDriveButtonText || 'product_details.test_drive_button' | translate }}
        </button>
    `,
    imports: [CommonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestDriveButtonComponent implements OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    public productPageData?: Partial<IProductPageResponse>;
    public show = false;

    @Input()
    public buttonClass?: string;

    // Remove from rendering flow
    @HostBinding('style')
    public get style() {
        if (!this.show) {
            return {
                display: 'none',
            };
        }
    }

    constructor(
        private readonly cd: ChangeDetectorRef,
        public readonly productPageService: ProductPageService
    ) {
        this.productPageService.productPageData$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
            if (data) {
                this.productPageData = data;
                this.show = this.productPageData.dealership?.location?.category?.code === 'retail';
            }
            this.cd.markForCheck();
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
